import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Table, DatePicker, Image } from "antd";
import Icon from "@ant-design/icons";
import { useUpdateEffect } from "../../utils/hooksUtil";
import SelectColumsModal from "../../components/modal/selectCloumsModal";
import CsvDownloadModal from "../../components/modal/csvDownloadModal";
import { useDispatch, useSelector } from "react-redux";
import {
  actions,
  fetchLiveFavoriteItem,
  fetchAnalyzeLive,
  updateCsvLiveFavoriteItem,
  csvDownloadLive,
} from "../../slices/analyzeLiveSlice";
import { validDatePickChecker, toMoneyString } from "../../utils/fnUtil";
import InfomationModal from "../../components/modal/infomationModal";
import Header from "../../components/header";
import Footer from "../../components/footer";
import Button from "../../components/button";
import Icons from "../../constants/Icons";
import TableColumnWidth from "../../constants/tableColumnWidth";
import moment from "moment";
import "./style.scss";

const AnalyzeLive = () => {
  const dispatch = useDispatch();
  const {
    analyzeList,
    searchParams,
    total,
    selectColumsVisible,
    showFields,
    csvDownloadModalVisible,
    filterContentsVisible,
    filterUserVisible,
    filterBrandVisible,
    filterShopVisible,
    filterList,
    favoriteItem,
    infomationModal,
    infomationTitle,
    flag,
  } = useSelector((state) => state.analyzeLive);

  const pageTitle = "コンテンツ分析 - ライブ配信";
  const columns = [
    {
      title: () => (
        <>
          <span>配信CD </span>
          <span onClick={createOnClikSort("live_code")}>
            {getSortIcon(formik.values.sort === "live_code_asc")}
          </span>
        </>
      ),
      dataIndex: "live_code",
      key: "live_code",
      label: "配信CD",
      align: "center",
      width: TableColumnWidth.analyzeLive.cd,
      render: (val) => val || "-",
    },
    {
      title: () => (
        <>
          <span>タイトル </span>
          <span onClick={createOnClikSort("live_title")}>
            {getSortIcon(formik.values.sort === "live_title_asc")}
          </span>
        </>
      ),
      dataIndex: "title",
      key: "live_title",
      label: "タイトル",
      align: "center",
      width: TableColumnWidth.title,
      render: (val) => val || "-",
    },
    {
      title: () => (
        <>
          <span>サムネイル画像 </span>
        </>
      ),
      dataIndex: "title_image_url",
      key: "title_image_url",
      label: "サムネイル画像",
      width: TableColumnWidth.image,
      render: (image) =>
        image ? (
          <Image src={image} width={100} height={100} />
        ) : (
          <Icon component={Icons.NoImgaeIcon} style={{ fontSize: 50 }} />
        ),
      align: "center",
    },
    {
      title: () => (
        <>
          <span>種別 </span>
          <span onClick={createOnClikSort("live_type")}>
            {getSortIcon(formik.values.sort === "live_type_asc")}
          </span>
          &nbsp;&nbsp;
          <Icon
            component={
              filterList.contents_type?.length === 0
                ? ""
                : !filterListContentsType && searchParams.live_flag?.length === 2
                ? Icons.FilterIcon
                : Icons.FilterUsedIcon
            }
            onClick={() => {
              dispatch(actions.openFilterContentsModal());
            }}
          />
        </>
      ),
      dataIndex: "contents_type",
      key: "live_type",
      label: "種別",
      align: "center",
      width: TableColumnWidth.analyzeLive.contentType,
      render: (val) => val || "-",
    },
    {
      title: () => (
        <>
          <span>社員 </span>
          <span onClick={createOnClikSort("user_name")}>
            {getSortIcon(formik.values.sort === "user_name_asc")}
          </span>
          &nbsp;&nbsp;
          <Icon
            component={
              filterList.user_info.length === 0
                ? ""
                : searchParams.user_code.length === 0
                ? Icons.FilterIcon
                : Icons.FilterUsedIcon
            }
            onClick={() => {
              dispatch(actions.openFilterUserModal());
            }}
          />
        </>
      ),
      key: "user_name",
      dataIndex: "user_name",
      label: "社員",
      align: "center",
      width: TableColumnWidth.analyzeLive.userName,
      render: (userName, data) => (
        <span className="display-linebreak">
          {userName
            ? `${userName}\n${
                data?.user_nickname ? `(${data?.user_nickname})` : ""
              }`
            : "-"}
        </span>
      ),
    },
    {
      title: () => (
        <>
          <span>店舗 </span>
          <span onClick={createOnClikSort("shop_name")}>
            {getSortIcon(formik.values.sort === "shop_name_asc")}
          </span>
          &nbsp;&nbsp;
          <Icon
            component={
              filterList.shop_info.length === 0
                ? ""
                : searchParams.shop_code.length === 0
                ? Icons.FilterIcon
                : Icons.FilterUsedIcon
            }
            onClick={() => {
              dispatch(actions.openFilterShopModal());
            }}
          />
        </>
      ),
      key: "shop_name",
      dataIndex: "shop_name",
      label: "店舗",
      align: "center",
      width: TableColumnWidth.analyzeLive.shopName,
      render: (val) => val || "-",
    },
    {
      title: () => (
        <>
          <span>ブランド </span>
          <span onClick={createOnClikSort("brand_name")}>
            {getSortIcon(formik.values.sort === "brand_name_asc")}
          </span>
          &nbsp;&nbsp;
          <Icon
            component={
              filterList.brand_info.length === 0
                ? ""
                : searchParams.brand_code.length === 0
                ? Icons.FilterIcon
                : Icons.FilterUsedIcon
            }
            onClick={() => {
              dispatch(actions.openFilterBrandModal());
            }}
          />
        </>
      ),
      key: "brand_name",
      dataIndex: "brand_name",
      label: "ブランド",
      align: "center",
      width: TableColumnWidth.analyzeLive.brandName,
      render: (val) => val || "-",
    },
    {
      title: () => (
        <>
          <span>配信日時 </span>
          <span onClick={createOnClikSort("datetime")}>
            {getSortIcon(formik.values.sort === "datetime_asc")}
          </span>
        </>
      ),
      key: "published_at",
      dataIndex: "published_at",
      label: "配信日時",
      align: "center",
      width: TableColumnWidth.date,
      render: (date) => (
        <span>{date ? moment(date).format("YYYY.MM.DD HH:mm") : "-"}</span>
      ),
    },
    {
      title: () => (
        <>
          <span>売上 </span>
          <span onClick={createOnClikSort("sales")}>
            {getSortIcon(formik.values.sort === "sales_asc")}
          </span>
        </>
      ),
      key: "earnings",
      dataIndex: "earnings",
      label: "売上",
      align: "center",
      width: TableColumnWidth.earnings,
      render: (val) => toMoneyString(val) || "-",
    },
    {
      title: () => (
        <>
          <span>件数 </span>
          <span onClick={createOnClikSort("order_count")}>
            {getSortIcon(formik.values.sort === "order_count_asc")}
          </span>
        </>
      ),
      key: "order_count",
      dataIndex: "order_count",
      label: "件数",
      align: "center",
      width: TableColumnWidth.orderCount,
      render: (val) => toMoneyString(val) || "-",
    },
    {
      title: () => (
        <>
          <span>商品点数 </span>
          <span onClick={createOnClikSort("qty")}>
            {getSortIcon(formik.values.sort === "qty_asc")}
          </span>
        </>
      ),
      key: "qty",
      dataIndex: "qty",
      label: "商品点数",
      align: "center",
      width: TableColumnWidth.qty,
      render: (val) => toMoneyString(val) || "-",
    },

    {
      title: () => (
        <>
          <span>視聴者数/再生回数 </span>
          <span onClick={createOnClikSort("pv")}>
            {getSortIcon(formik.values.sort === "pv_asc")}
          </span>
        </>
      ),
      key: "pv_count",
      dataIndex: "pv_count",
      label: "視聴者数/再生回数",
      align: "center",
      width: TableColumnWidth.pv,
      render: (val) => toMoneyString(val) || "-",
    },
    {
      title: () => (
        <>
          <span>いいね数 </span>
          <span onClick={createOnClikSort("like")}>
            {getSortIcon(formik.values.sort === "like_asc")}
          </span>
        </>
      ),
      key: "like_count",
      dataIndex: "like_count",
      label: "いいね数",
      align: "center",
      width: TableColumnWidth.like,
      render: (val) => toMoneyString(val) || "-",
    },
  ];
  const favoriteItemOptions = [
    { label: "配信CD", value: "live_cd" },
    { label: "ブランドCD", value: "brand_cd" },
    { label: "タイトル", value: "title" },
    { label: "ブランド名", value: "brand_name" },
    { label: "種別", value: "live_type" },
    { label: "配信日時", value: "release_date" },
    { label: "社員CD", value: "user_cd" },
    { label: "売上", value: "sales" },
    { label: "社員名", value: "user_name" },
    { label: "件数", value: "count" },
    { label: "サイト表示名", value: "user_nickname" },
    { label: "商品点数", value: "order_qty" },
    { label: "店舗CD", value: "shop_cd" },
    { label: "視聴者数/再生回数", value: "pv_total" },
    { label: "店舗名", value: "shop_name" },
    { label: "いいね数", value: "like_total" },
  ];
  const displayColumnOptions = [
    { label: "配信CD", value: "live_code" },
    { label: "売上", value: "earnings" },
    { label: "タイトル", value: "live_title" },
    { label: "件数", value: "order_count" },
    { label: "サムネイル画像", value: "title_image_url" },
    { label: "商品点数", value: "qty" },
    { label: "種別", value: "live_type" },
    { label: "視聴者数/再生回数", value: "pv_count" },
    { label: "社員", value: "user_name" },
    { label: "いいね数", value: "like_count" },
    { label: "店舗", value: "shop_name" },
    null,
    { label: "ブランド", value: "brand_name" },
    null,
    { label: "配信日時", value: "published_at" },
  ];
  const screenType = 7;

  const formik = useFormik({
    initialValues: searchParams,
    onSubmit: (values) =>
      dispatch(
        actions.saveSearchParam({
          user_code: flag ? [] : searchParams.user_code,
          brand_code : flag ? [] : searchParams.brand_code,
          shop_code : flag ? [] : searchParams.shop_code,
          start_date: analyzeDate.from?.format("YYYY-MM-DD"),
          end_date: analyzeDate.to?.format("YYYY-MM-DD"),
        })
      ),
  });
  const [analyzeDate, setAnalyzeDate] = useState({ from: null, to: null });
  const [filterListContentsType, setFilterListContentsType] = useState(null);

  useEffect(() => {
    return () => dispatch(actions.clear());
  }, []);
  useEffect(() => {
    dispatch(fetchLiveFavoriteItem({ screen_type: screenType }));
    dispatch(actions.saveShowFields(columns));
  }, []);
  useUpdateEffect(() => {
    if (isValidFormVal(searchParams)) {
      dispatch(fetchAnalyzeLive(searchParams));
    } else {
      dispatch(actions.openInfomationModal("集計期間は必須です"));
    }
  }, [searchParams, dispatch]);
  useEffect(() => {
    dispatch(actions.saveShowFields(columns));
  }, [analyzeList]);
  const createOnClikSort = (field, customDesc, customAsc) => () => {
    const desc = customDesc ?? `${field}_desc`;
    const asc = customAsc ?? `${field}_asc`;
    const targetSort =
      formik.values.sort === desc
        ? asc
        : formik.values.sort === asc
        ? desc
        : asc;
    dispatch(actions.saveSearchParam({ sort: targetSort }));
    formik.setFieldValue("sort", targetSort);
  };
  const datePickerStyle = {
    backgroundColor: "white",
    fontSize: 16,
    height: 32,
    width: 120,
  };
  const getSortIcon = (sort) => {
    return sort ? (
      <>
        &nbsp;
        <Icon component={Icons.SortAscendingIcon} style={{ fontSize: 10 }} />
      </>
    ) : (
      <>
        &nbsp;
        <Icon component={Icons.SortDescendingIcon} style={{ fontSize: 10 }} />
      </>
    );
  };
  const isValidFormVal = (_searchParams) => {
    return _searchParams.start_date && _searchParams.end_date;
  };
  return (
    <div className="content-body">
      <SelectColumsModal
        title="表示する項目を選択してください"
        modalVisible={selectColumsVisible}
        closeModal={() => dispatch(actions.closeSelectColumsModal())}
        options={displayColumnOptions}
        onDisplay={(checkedList) => {
          dispatch(
            actions.saveShowFields(
              columns.filter((col) =>
                checkedList.some((checkedCol) => checkedCol === col.key)
              )
            )
          );
        }}
        chekedValues={displayColumnOptions.map((opt) => opt?.value)}
        colSpan={12}
        initialize={false}
      />
      <SelectColumsModal
        title="絞り込む種別を選択してください"
        modalVisible={filterContentsVisible}
        closeModal={() => dispatch(actions.closeFilterContentsModal())}
        options={
          filterList.contents_type.map((contents) => {
            const contentsValue = (() => {
              if (contents === 'オンラインライブ') return '0';
              if (contents === 'アーカイブ') return '1';
            })();
            if (contentsValue) {
              return { label: contents, value: contentsValue };
            }
          })
          .filter((e) => e)
        }
        onDisplay={(checkedList) => {
          if (checkedList.length == 2) {
            setFilterListContentsType(true);
          } else {
            setFilterListContentsType(null);
          }
          dispatch(
            actions.saveSearchParam({
              live_flag: checkedList.length == 2 || checkedList.length == 0 ? ['0', '1'] : checkedList,
            })
          );
        }}
        chekedValues={(() => {
          const result = (() => {
            if (searchParams?.live_flag == 0) return ["0"];
            if (searchParams?.live_flag == 1) return ["1"];
            return [];
          })();
          return filterListContentsType ? ['0', '1'] : result;
        })()}
        colSpan={24}
      />
      <SelectColumsModal
        title="絞り込む社員を選択してください"
        modalVisible={filterUserVisible}
        closeModal={() => dispatch(actions.closeFilterUserModal())}
        options={filterList.user_info
          .map((user) => {
            if (user?.user_code) {
              return {
                label: `${user?.user_code} ${user?.user_name || ""}${
                  user?.user_nickname ? `(${user?.user_nickname})` : ""
                }`,
                value: user?.user_code || "-",
              };
            }
          })
          .filter((e) => e)}
        onDisplay={(checkedList) => {
          dispatch(
            actions.saveSearchParam({
              user_code: checkedList,
            })
          );
        }}
        chekedValues={searchParams.user_code}
        colSpan={24}
      />
      <SelectColumsModal
        title="絞り込む店舗を選択してください"
        modalVisible={filterShopVisible}
        closeModal={() => dispatch(actions.closeFilterShopModal())}
        options={filterList.shop_info
          .map((shop) => {
            if (shop?.shop_code) {
              return {
                label: `${shop.shop_code} ${shop.shop_name || ""}`,
                value: shop.shop_code,
              };
            }
          })
          .filter((e) => e)}
        onDisplay={(checkedList) => {
          dispatch(actions.saveSearchParam({ shop_code: checkedList }));
        }}
        chekedValues={searchParams.shop_code}
        colSpan={24}
      />
      <SelectColumsModal
        title="絞り込むブランドを選択してください"
        modalVisible={filterBrandVisible}
        closeModal={() => dispatch(actions.closeFilterBrandModal())}
        options={filterList.brand_info
          .map((brand) => {
            if (brand?.brand_code) {
              return {
                label: `${brand.brand_code} ${brand?.brand_name || ""}`,
                value: brand.brand_code,
              };
            }
          })
          .filter((e) => e)}
        onDisplay={(checkedList) => {
          dispatch(actions.saveSearchParam({ brand_code: checkedList }));
        }}
        chekedValues={searchParams.brand_code}
        colSpan={24}
      />
      <CsvDownloadModal
        modalVisible={csvDownloadModalVisible}
        options={favoriteItemOptions.map((opt) => {
          return { ...opt, colSpan: 12 };
        })}
        favoriteItem={favoriteItem}
        onFavoriteItem={(checkedList) => {
          let param = {
            screen_type: screenType,
            favorite: {},
          };
          favoriteItemOptions.forEach(
            (item) => (param.favorite[item.value] = "0")
          );
          checkedList.forEach((item) => (param.favorite[item] = "1"));
          dispatch(updateCsvLiveFavoriteItem(param));
        }}
        onClose={() => dispatch(actions.closeCsvDownloadModal())}
        onDownload={(checkedList) => {
          if (isValidFormVal(searchParams)) {
            dispatch(
              csvDownloadLive({
                screen_type: screenType,
                start_date: searchParams.start_date,
                end_date: searchParams.end_date,
                user_code: searchParams.user_code,
                shop_code: searchParams.shop_code,
                brand_code: searchParams.brand_code,
                columns: checkedList,
              })
            );
          } else {
            dispatch(actions.openInfomationModal("集計期間は必須です"));
          }
        }}
      />
      <InfomationModal
        modalVisible={infomationModal}
        item={{ information_title: infomationTitle }}
        setModalVisible={() => {
          dispatch(actions.closeInfomationModal());
        }}
      />
      <Header />
      <div className="analyzeMovie-container nf-page">
        <h2>{pageTitle}</h2>
        <form className="search-area" onSubmit={formik.handleSubmit}>
          <div className="search-item">
            <div className="nf-input-wrapper nf-input-wrapper-middle">
              <label class="nf-input-label text-align-center nf-analyze-required">
                集計期間
              </label>
              <DatePicker
                size="small"
                format={"YYYY.MM.DD"}
                placeholder=""
                suffixIcon={<span style={{ paddingLeft: 10 }}></span>}
                style={datePickerStyle}
                value={analyzeDate.from}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                onChange={(val, dateString) => {
                  validDatePickChecker(
                    dateString,
                    "from",
                    analyzeDate,
                    setAnalyzeDate
                  );
                }}
              />
              <span style={{ width: 40 }}>　〜　</span>
              <DatePicker
                size="small"
                format={"YYYY.MM.DD"}
                placeholder=""
                suffixIcon={<span style={{ paddingLeft: 10 }}></span>}
                style={datePickerStyle}
                value={analyzeDate.to}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                onChange={(val, dateString) => {
                  validDatePickChecker(
                    dateString,
                    "to",
                    analyzeDate,
                    setAnalyzeDate
                  );
                }}
              />
            </div>
          </div>
          <Button
            text="検索"
            type="submit"
            disabled={!analyzeDate.from || !analyzeDate.to}
            onClick={() => {
              if (searchParams?.user_code?.length !== 0 || searchParams?.shop_code?.length !== 0 || searchParams?.brand_code?.length !== 0) {
                dispatch(
                  actions.saveSearchParam({
                    user_code: [],
                    shop_code: [],
                    brand_code: [],
                  })
                );
              }
              dispatch(actions.changeFlag());
            }}
          />
        </form>
        <div className="table-header">
          <div className="top-header">
            <Button
              text="CSV出力"
              width="wider"
              style={{ display: "block", marginBottom: 5, marginLeft: "auto" }}
              onClick={() => dispatch(actions.openCsvDownloadModal())}
            />
          </div>
          <div className="bottom-header">
            <h3>検索結果一覧</h3>
            <div style={{ display: "flex" }}>
              <Button
                text="フィルター解除"
                theme="white"
                width="wider"
                disabled={
                  analyzeList.length === 0
                  && searchParams?.user_code?.length === 0
                  && searchParams?.shop_code?.length === 0
                  && searchParams?.brand_code?.length === 0
                }
                onClick={() => {
                  setFilterListContentsType(null);
                  dispatch(
                    actions.saveSearchParam({
                      live_flag: [0, 1],
                      user_code: [],
                      shop_code: [],
                      brand_code: [],
                    })
                  );
                }}
              />
              <Button
                text="表示切替"
                width="wider"
                style={{
                  backgroundColor: "#f3f3f3",
                  border: "none",
                  color: "black",
                  marginLeft: 15,
                }}
                onClick={() => {
                  dispatch(actions.openSelectColumsModal());
                }}
              />
            </div>
          </div>
        </div>
        <Table
          columns={showFields}
          dataSource={analyzeList}
          onChange={(pagination) => {
            const offset =
              pagination.current === 1
                ? 0
                : pagination.pageSize * (pagination.current - 1);
            dispatch(actions.saveOffset(offset));
            formik.setFieldValue("offset", offset);
          }}
          pagination={{
            total,
            pageSize: 10,
            current: (searchParams?.offset || 0) / 10 + 1,
            position: ["bottomCenter"],
            showQuickJumper: false,
            size: "small",
          }}
          sticky={{offsetHeader: 60}}
        />
      </div>
      <Footer />
    </div>
  );
};

export default AnalyzeLive;
